module.exports = __webpack_public_path__ + "img/728x90.74447e36.png";